module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gallery",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('swiper', {
    ref: "mySwiper",
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "options": _vm.swiperOption
    }
  }, [_vm._l((_vm.getImages()), function(slide, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('img', {
      staticStyle: {
        "width": "auto",
        "margin": "0 auto"
      },
      attrs: {
        "src": slide.src
      }
    })])
  }), _vm._v(" "), (false) ? _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "swiper-button-prev",
    attrs: {
      "slot": "button-prev"
    },
    slot: "button-prev"
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "swiper-button-next",
    attrs: {
      "slot": "button-next"
    },
    slot: "button-next"
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "swiper-scrollbar",
    attrs: {
      "slot": "scrollbar"
    },
    slot: "scrollbar"
  }) : _vm._e(), _vm._v(" "), (false) ? _c('div', {
    staticClass: "swiper-pagination",
    attrs: {
      "slot": "pagination"
    },
    slot: "pagination"
  }) : _vm._e()], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ce56113"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Swiper.vue
// module id = 225
// module chunks = 1